<template>
  <div class="login">
    <div class="header">
      <router-link to="/connexion" class="header_element">
        <!--        <span class="icon icon-left-arrow icon-lg"></span>-->
        <!--        <font-awesome-icon size="lg" color="#00d6ff" :icon="['fas','arrow-left']"/>-->
        <font-awesome-icon color="#00d7fe" class="reverse mobile" size="3x" icon="angle-right"/>

      </router-link>
      <!--      <p class="header_element">{{ their_type }}</p>-->
    </div>
    <div class="content">

      <div class="logo" v-if="their_type!=='inscription'">
        <img src="assets/logo.png" alt="">
      </div>
      <div class="formLogin">

        <input class="form_input" v-model="input.username" type="text" placeholder="Pseudo" required>

        <input type="text" class="form_input code" v-model="input.code" placeholder="Code ex: AH-678-765" maxlength=10
               @keyup="checkFormat()" required
               v-if="their_type==='inscription'">

        <input class="form_input" v-model="input.plainPassword" v-if="their_type==='connexion'" type="password"
               placeholder="Mot de passe" required>

        <input v-if="their_type === 'inscription' || their_type==='rp'"
               :class="[(their_type==='rp'||input.checkregister)?'active':'']" v-model="input.email"
               class="form_input mail" type="mail"
               placeholder="Email" required>

        <div class="warning" v-if="their_type==='inscription'">
          <p>Le code sera votre mot de passe en tant que guest, mais pour ne perdre aucune donnée inscrivez vous celà ne
            prend pas plus de temps que de lire ceci.</p>
          <input type="checkbox" name="checkregister" id="checkregister" v-model="input.checkregister"/><label
            for="checkregister">S'inscrire</label>
        </div>

        <!--      <input class="form_input" v-model="input.plainPassword" type="password" v-if="their_type!== 'rp' && input.checkregister" placeholder="Mot de passe" required>-->
        <!--      <input v-if="their_type === 'inscription' && input.checkregister" v-model="input.confirmPassword" class="form_input" type="password"-->
        <!--             placeholder="Confirmation mot de passe" required>-->

      </div>
      <div class="content_response">
        <transition-group enter-active-class="animated bounceIn" name="list" tag="p"
                          leave-active-class="animated fadeOut">
          <div v-for="(response,index) in responses" class="form_response" :class="response.type" :key="index+'-p'">
            <p>{{ response.msg }}</p>
            <span v-if="response.value">{{ response.value }}</span>
          </div>
        </transition-group>
      </div>
      <div class="connexion" v-if="their_type === 'connexion'">
        <button class="button blue" v-on:click="loginUser()">Connexion</button>
        <span @click="changeType('rp')">J'ai oublié mon mot de passe</span>
      </div>
      <div class="connexion" v-else-if="their_type === 'inscription'">
        <button class="button blue" v-on:click="registerUser()">{{
            input.checkregister ? 'S\'inscrire' : 'Commencer'
          }}
        </button>

        <!--      <span @click="changeType('inscription')">M'inscrire</span>-->
      </div>
      <div class="connexion" v-else>
        <button class="button blue" v-on:click="mailResetPassword()">Valider</button>
        <!--      <span @click="changeType('connexion')">Me connecter</span>-->

      </div>
    </div>
  </div>
</template>

<script>
import {store} from '../store/store';
import {getMasks} from "@/service";
import {mapActions} from 'vuex'
import Loader from '../components/Loader/Loader.vue'
import router from "../router";


export default {

  name: 'Login',
  components: {
    Loader
  },
  data() {
    return {
      store,
      their_type: '',
      responses: null,
      input: {
        username: "",
        plainPassword: "",
        email: "",
        confirmPassword: "",
        code: "",
        checkregister: false
      }
    }
  },
  methods: {

    ...mapActions([
      'login',
      'register',
      'resetPassword',
      'userExist'
    ]),
    changeType(type) {
      this.their_type = type
    },
    checkFormat() {
      let value = this.input.code
      if (value.length > 0) {
        let text = value.split('-').join('').split(' ').join('');
        if (text.length > 2) {
          let prefix = text.slice(0, 2)
          if (text.length > 3) {
            let codepart1 = text.slice(2, 5)
            if (text.length > 5 && text.length < 10) {
              let codepart2 = text.slice(5)
              this.input.code = `${prefix}-${codepart1}-${codepart2}`

            } else {
              this.input.code = this.input.code.length < 9 ? `${prefix}-${codepart1}${text.slice(5)}` : this.input.code;
            }
          }
        }
      }

    }
    ,
    registerUser() {
      const {username, email, code, checkregister} = this.input;
      this.responses = null
      if (username === '' || (email === "" && checkregister === "") || code === "") {
        this.responses = [{
          msg: "Les champs ne doivent pas être vide",
          type: "error"
        }]
        this.removeResponse()

      } else {
        this.register({pseudo: username, email: email, code: code, checkregister: checkregister}).then(res => {
          this.responses = res
          this.removeResponse()

          if (res[0].type === 'succeed') {

            router.push({name: "login", params: {type: 'connexion'}})

          }

        })
      }
    },
    setUser(user) {
      this.store.commit('setUser', user);
    },
    setMasks(masks) {
      this.store.commit('setMasks', masks);
    },
    loginUser() {
      const {username, plainPassword} = this.input;
      if (username === '' || plainPassword === "") {
        this.responses = [
          {
            msg: "les champs ne doivent pas être vide",
            type: 'error'
          }
        ]
      } else {
        toggleLoader()
        this.login({pseudo: username, password: plainPassword}).then(res => {
          this.responses = res
        })

      }
    },
    removeResponse(list = this.responses) {

      setTimeout(function () {
        list.shift()
        if (list.length > 0) {
          this.removeResponse(list)
        }
      }.bind(this), 2000)

    },
    mailResetPassword() {
      const {username, email} = this.input;
      this.responses = null
      if (username === '' || email === "") {
        this.responses = [{
          msg: "Les champs ne doivent pas être vide",
          type: "error"
        }]
        this.removeResponse()

      } else {

        this.userExist({pseudo: username, email: email}).then(res => {
          this.responses = [res]
          this.removeResponse()

          if (res.status_code === 200) {
            this.resetPassword(res.p).then(res => {
              this.responses = [res]
            })
          }
        })
        // this.resetPassword()

      }
    }
  },
  mounted() {
    this.their_type = this.$route.params.type;
  },
  updated() {

  }
}
</script>

<style scoped>

.header {
  padding: 20px;
}

.login {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.logo {
  display: flex;
}

.logo img {
  margin: auto;
}

.formLogin {
  display: flex;
  flex-direction: column;
  margin: 20px;
}

.logo img {
  width: 35%;
}


/*   OLD FORM INPUT

.form_input {
  font-size: 16px;
  border: none;
  border-bottom: 1px solid #00d6ff;
  padding:15px 20px;
  margin:5px 0 ;
}*/

.form_input {
  font-size: 11px;
  border: 1px solid #6e6c6c;
  box-shadow: 0px 3px 9px 1px rgba(0, 0, 0, 0.22);
  border-radius: 7px;
  padding: 10px 20px;
  margin: 7px 0;
  transition: .3s;
}

.form_input.mail {
  margin-top: -20px;
  opacity: 0;
  visibility: hidden;
}

.form_input.mail.active {
  visibility: visible;
  margin-top: 7px;
  opacity: 1;
}

.form_input:focus {
  outline: none;
}

.form_response.error {
  width: 75%;
  margin: 15px auto auto auto;
  background-color: #ff3333;
  color: #fff;
  border-radius: 10px;
  /*position: absolute;*/
  /*font-family: "Bebas Neue";*/
}

.form_response.succeed {
  width: 75%;
  margin: 15px auto auto auto;
  background-color: #65c249;
  color: #fff;
  border-radius: 10px;
  /*position: absolute;*/
  /*font-family: "Bebas Neue";*/
}

.warning {
  border: 1px solid orange;
  border-radius: 5px;
  padding: 5px 10px;
  background: rgba(255, 165, 0, 0.46);
}

.content_response {
  position: absolute;
  top: 0;
  width: 100%;
}

.form_response p {
  /*font-family: Calibri;*/
  text-align: center;
  padding: 10px 10px;
  white-space: pre-line;
  font-weight: bold;
}

.code {
  text-transform: uppercase;
}

.login {
}

.connexion {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.connexion span {
  margin: 10px;
  transition: .3s;
}

.connexion span:hover {
  color: var(--main-color-darkness);
  cursor: pointer;
}

.button {
  color: #fff;
  padding: 10px;
  font-size: 20px;
  width: 60%;
  border-radius: 10px;
  margin: auto;
  border: none;
  text-transform: uppercase;
  font-family: var(--main-title-font);
  box-shadow: 0px 3px 9px 1px #0000004f;
}

.red {
  background-color: red;
}

.blue {
  background: linear-gradient(#00CDF8, #00ABDD);
  /*transition:.3s;*/
  /*border:2px solid transparent;*/
}

.blue:hover {
  color: #00CDF8;
  border: 2px solid #00CDF8;
  background: #fff;
  cursor: pointer;
}

@media screen and (min-width: 780px) {
  .logo img {
    width: 20%;
  }

  .formLogin, .connexion {
    width: 30%;
    margin: auto;
  }

  .formLogin {
    margin: 40px auto;
  }


}

</style>
